
import joblocation1 from "../../assets/images/joblocation1.png";
import joblocation2 from "../../assets/images/joblocation2.png";
import joblocation3 from "../../assets/images/joblocation3.png";
import joblocation4 from "../../assets/images/joblocation4.png";
import joblocation5 from "../../assets/images/joblocation5.png";
import joblocation6 from "../../assets/images/joblocation6.png";

const JobsByLocation: React.FC = () => (
  <>
    <section className="bg-[#EAF0F6]">
      {/* Heading */}
      <div className=" max-w-7xl mx-auto px-4 md:px-8 xl:pt-20 lg:pt-16 py-10">
        <div className="text-center mb-10">
          <h1 className="xl:text-5xl md:text-4xl text-3xl font-extrabold lg:mb-6 mb-4 leading-tight">
            <span className="text-[#C40808]">Jobs by </span>
            <span className="text-[#0E313A]"> Location</span>
          </h1>
          <p className="mb-7 text-[#666666] text-base font-medium leading-7">
            Find your favourite jobs and get the benefits of yourself
          </p>
        </div>
        <div className="flex md:flex-row flex-col w-full gap-6 mb-6">
          <div className="bg-white shadow rounded-xl p-2 flex flex-col md:w-[28%]">
            <img
              src={joblocation1}
              alt="job location 1"
              className="h-40 object-cover rounded-xl mb-4 w-full"
            />
            <div className="flex flex-col gap-2 px-2 pb-4">
              <h3 className="text-lg font-bold text-[#05264E]"> Denmark</h3>
              <div className="flex justify-between text-[#66789C] text-sm">
                <span>3 Vacancies</span>
                <span>2 Companies</span>
              </div>
            </div>
          </div>
          <div className="bg-white shadow rounded-xl p-2 flex flex-col md:w-[32%]">
            <img
              src={joblocation2}
              alt="job location 1"
              className="h-40 object-cover rounded-xl mb-4 w-full"
            />
            <div className="flex flex-col gap-2 px-2 pb-4">
              <h3 className="text-lg font-bold text-[#05264E]">France</h3>
              <div className="flex justify-between text-[#66789C] text-sm">
                <span>0 Vacancies</span>
                <span>4 Companies</span>
              </div>
            </div>
          </div>
          <div className="bg-white shadow rounded-xl p-2 flex flex-col md:w-[40%]">
            <img
              src={joblocation3}
              alt="job location 3"
              className="h-40 object-cover rounded-xl mb-4 w-full"
            />
            <div className="flex flex-col gap-2">
              <h3 className="text-lg font-bold text-[#05 px-2 pb-4264E] mb-1">
                Germany
              </h3>
              <div className="flex justify-between text-[#66789C] text-sm">
                <span>1 Vacancies</span>
                <span>3 Companies</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex md:flex-row flex-col w-full gap-6 mb-14">
          <div className="bg-white shadow rounded-xl p-2 flex flex-col md:w-[32%]">
            <img
              src={joblocation4}
              alt="job location 1"
              className="h-40 object-cover rounded-xl mb-4 w-full"
            />
            <div className="flex flex-col gap-2 px-2 pb-4">
              <h3 className="text-lg font-bold text-[#05264E]">Holland</h3>
              <div className="flex justify-between text-[#66789C] text-sm">
                <span>1 Vacancies</span>
                <span>4 Companies</span>
              </div>
            </div>
          </div>
          <div className="bg-white shadow rounded-xl p-2 flex flex-col  md:w-[40%]">
            <img
              src={joblocation5}
              alt="job location 5"
              className="h-40 object-cover rounded-xl mb-4 w-full"
            />
            <div className="flex flex-col gap-2 px-2 pb-4">
              <h3 className="text-lg font-bold text-[#05264E]">London</h3>
              <div className="flex justify-between text-[#66789C] text-sm">
                <span>2 Vacancies</span>
                <span>2 Companies</span>
              </div>
            </div>
          </div>
          <div className="bg-white shadow rounded-xl p-2 flex flex-col md:w-[28%]">
            <img
              src={joblocation6}
              alt="job location 6"
              className="h-40 object-cover rounded-xl mb-4 w-full"
            />
            <div className="flex flex-col gap-2">
              <h3 className="text-lg font-bold text-[#05 px-2 pb-4264E] mb-1">
                USA
              </h3>
              <div className="flex justify-between text-[#66789C] text-sm">
                <span>4 Vacancies</span>
                <span>4 Companies</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Download Brochure Section */}
    </section>

  </>
);

export default JobsByLocation;
